<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full" style="background-color: #262d4a">
    <div class="vx-col sm:w-1/2 md:w-2/5 lg:w-2/5 xl:w-1/4 mx-auto self-center">
      <img style="width:100%;" class="mb-3" :src="siteLogoUrl"/>
      <b-overlay
        id="overlay-background"
        :show="overlayVisible"
        variant="tranparent"
        opacity=0.85
        blur="5px"
        rounded="sm"
      >
        <vx-card card-background="#11193f" class="glow-effect_white mb-4">
          <p style="color: rgb(150, 150, 150); font-weight: 600; font-family: Montserrat;font-size: 16px;" class="mb-3 mt-1">Login Details</p>
          <vx-input-group id="email_inputgroup" class="mb-4">
            <template slot="prepend">
              <div class="prepend-text school-primary_gradient">
                <span><feather-icon class="pt-1" id="user-email-icon" icon="UserIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-input
              id="email_input"
              autocomplete="off"
              onClick="this.select();"
              @click="stopLoading"
              placeholder="Email"
              v-model="email"
              class="w-full no-icon-border theme-dark digi_input"
              size="large"
            />
          </vx-input-group>

          <vx-input-group id="password_inputgroup">
            <template slot="prepend">
              <div class="prepend-text school-primary_gradient">
                <span><feather-icon class="pt-1" id="user-password-icon" icon="LockIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-input
              id="password_input"
              autocomplete="off"
              onClick="this.select();"
              @click="stopLoading"
              type="password"
              placeholder="Password"
              v-model="password"
              class="w-full no-icon-border theme-dark digi_input"
              size="large"
            />
          </vx-input-group>

          <div class="pb-12 pt-3">
            <vs-button :disabled="!email && !password" color="warning" style="border-radius:12px" type="border" ref="reset" class="mt-2 float-right vs-con-loading__container ml-3" @click="email = ''; password = ''"><strong>Reset</strong></vs-button>
            <vs-button :disabled="!email || !password" style="border-radius:12px" ref="login" class="mt-2 float-right vs-con-loading__container school-primary_gradient glow-effect_tertiary" @click="login"><img style="float:left; margin-left:-7px; margin-right:5px; margin-top:-2px; height:20px" src="https://lateralscaffolding.blob.core.windows.net/resources/icon-login-hover.png"/><strong>Login</strong></vs-button>
          </div>

          <div class="mt-6 mb-12">
            <p class="float-right" style="color: rgb(130, 130, 130);">Forgot password? Click <router-link class="text__school-tertiary-color" :to="{ name: 'forgotPassword', params: { emailParam: email } }"><strong>here</strong></router-link></p>
          </div>
        </vx-card>

        <vx-card v-show="notFET" id="register-card" class="glow-effect_primary school-primary_gradient">
          <template slot="no-body">
            <img :src="registerLogo" alt="user-profile-cover" class="responsive" style="border-radius: 7px;">
            <div class="card-overlay text-white justify-between">
              <vs-button color="#262d4a" class="glow-effect_tertiary" ref="register" style="position: absolute;right: 11%;bottom: 12%;border-radius:12px;" @click="viewRegisterPage"><strong>REGISTER</strong></vs-button> <!-- https://lateralscaffolding.z1.web.core.windows.net/registration/index.html -->
            </div>
          </template>
        </vx-card>

        <template #overlay>
          <div class="text-center text-white">
            <b-icon icon="stopwatch" font-scale="4" animation="throb" />
            <p id="cancel-label" style="font-size:14pt" class="mt-2">
              Please wait...
            </p>
          </div>
        </template>
      </b-overlay>

      <div class="mt-4" style="text-align: center;">
        <span style="color: lightgray">COPYRIGHT @ {{ new Date().getFullYear() }} Lateral Scaffolding | Powered by <a href="https://DigiCentral.co.za" style="color: #52b75d" target="_blank" rel="nofollow">DigiCentral.co.za</a>. All rights Reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      backgroundLoading: "#fff",
      email: "",
      password: "",
      checkbox_remember_me: false,
      welcomeCaption: "",
      overlayVisible: false
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != "" && this.password != "";
    },
    siteLogoUrl: function() {
      if (this.$store.state.schoolTheme == "digi") {
        return "https://lateralscaffolding.blob.core.windows.net/resources/logo-if-on-white.png";
      }
      else if (this.$store.state.schoolTheme == "istudy") {
        return "https://lateralscaffolding.blob.core.windows.net/resources/i-study-logo.png";
      }
      else if (this.$store.state.schoolTheme == "wced") {
        return "https://lateralscaffolding.blob.core.windows.net/resources/wced-logo.gif";
      }
      else if (this.$store.state.schoolTheme == "swales") {
        return "https://lateralscaffolding.blob.core.windows.net/resources/swales-logo.png";
      }
      else if (this.$store.state.schoolTheme == "ligbron") {
        return "https://lateralscaffolding.blob.core.windows.net/resources/ligbron-logo.png";
      }
      else if (this.$store.state.schoolTheme == "moetapele") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/moetapele-logo.png';
      }
      else if (this.$store.state.schoolTheme == "spesres") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/spesres-logo-new.png';
      }
      else if (this.$store.state.schoolTheme == "bdce") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/bdce-logo.png';
      }
      else if (this.$store.state.schoolTheme == "digicentral") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/digicentral-logo.png';
      }
      else if (this.$store.state.schoolTheme == "shayela") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/shayela-logo.png';
      }
      else if (this.$store.state.schoolTheme == "sonke") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/i-study-logo.png';
      }
      else if (this.$store.state.schoolTheme == "route") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/route-logo.png';
      }
      else if (this.$store.state.schoolTheme == "e-ligbron") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/ligbron-e-logo.png';
      }
      else if (this.$store.state.schoolTheme == "cocacola") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/coca-cola.svg';
      }
      else if (this.$store.state.schoolTheme == "bhekafunda") {
        return 'https://lateralscaffolding.blob.core.windows.net/resources/bheka-funda-logo-colour.png';
      }
    },
    registerLogo: function() {
      //var images = "";
      //var result = "";

      if (this.$store.state.schoolTheme == "digi" || this.$store.state.schoolTheme == "swales" || this.$store.state.schoolTheme == "ligbron") {
        return "https://lateralscaffolding.blob.core.windows.net/resources/register_bg-transparent_with-text.png";
      }
      else {
        return "https://lateralscaffolding.blob.core.windows.net/resources/register_bg-transparent-white-with-text.png";
      }
    },
    notFET: function() {
      if (window.location.href.includes("edu.lateralscaffolding")) {
        return false;
      }
      else if (window.location.href.includes("digi.lateralscaffolding")) {
        return true;
      }
      else if (window.location.href.includes("wc.lateralscaffolding")) {
        return true;
      }
      else if (window.location.href.includes("swales.lateralscaffolding")) {
        return false;
      }
      else if (window.location.href.includes("ligbron.lateralscaffolding")) {
        return false;
      }
      else if (window.location.href.includes("moetapele.lateralscaffolding")) {
        return false;
      }
      else if (window.location.href.includes("spesres.lateralscaffolding")) {
        return false;
      }
      else if (window.location.href.includes("edu-lateralscaffolding-com-spesres.datafree")) {
        return false;
      }
      else if (window.location.href.includes("bdce.lateralscaffolding")) {
        return false;
      }
      else if (window.location.href.includes("digicentral.lateralscaffolding")) {
        return false;
      }
      else if (window.location.href.includes("shayela.lateralscaffolding")) {
        return false;
      }
      else if (window.location.href.includes("lms.i-study.co.za")) {
        return false;
      }
      else if (window.location.href.includes("route.lateralscaffolding")) {
        return true;
      }
      else if (window.location.href.includes("les.lateralscaffolding")) {
        return false;
      }
      else if (window.location.href.includes("bhekafunda.lateralscaffolding")) {
        return false;
      }
      else if (window.location.href.includes("growmybusiness")) {
        return false;
      }
      else {
        return true;
      }
    },
  },
  mounted() {
    var self = this;

    if (self.$route.query.sessionExpired) {
      self.$swal({
        title: 'Session Invalid',
        icon: 'warning',
        backdrop: true,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Reset Password',
        html: `Your previous session is no longer valid because it has expired or your login details have been used on another device or browser. If this behavior is unexpected, please reset your password.`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-3',
          cancelButton: 'vs-component vs-button vs-button-warning vs-button-border ml-3'
        },
        showClass: {
          popup: 'animate__animated animate__tada',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) { // <-- if confirmed
          self.$router.push({ name: 'forgotPassword', params: { emailParam: email } });
        } else {
          window.history.pushState(null, 'DigiCampus', '/login');
        }
      });
    }

    console.log(`Theme Mode: ${self.$store.state.theme ? self.$store.state.theme : 'Theme not set'}`);
    console.log(`School Theme: ${self.$store.state.schoolTheme ? self.$store.state.schoolTheme : 'School theme not set'}`);

    var lpToContinueFrom = localStorage.getItem("lpToContinueFrom");
    localStorage.removeItem("redirectedFromPublicSite");
    localStorage.clear();
    // sessionStorage.clear();
    localStorage.setItem("isStudent", "false");
    localStorage.setItem('type', 'digi');
    self.setCaption();
    localStorage.setItem('Current_User_Id', '');

    if (lpToContinueFrom && lpToContinueFrom != "null") {
      localStorage.setItem("lpToContinueFrom", lpToContinueFrom);
    }

    window.addEventListener("keyup", self.eventListenerFunc, false);

    if(self.$route.query.token && self.$route.query.email)
    {
      self.overlayVisible = true;
      var token = self.$route.query.token.trim();
      var email = self.$route.query.email.trim();

      localStorage.setItem('userInfo', '');
      const payload = {
        checkbox_remember_me: false,
        userDetails: {
          email: email,
          token: token
        },
        notify: self.$vs.notify,
        self: self
      };
      self.$store.dispatch("auth/loginAttempt", payload);
      return;
    }

    if(self.$route.query.externalString)
    {
      self.overlayVisible = true;
      var key = self.$route.query.externalString.trim();

      localStorage.setItem('userInfo', '');
      const payload = {
        checkbox_remember_me: false,
        userDetails: {
          externalString : key
        },
        notify: self.$vs.notify,
        self: self
      };
      self.$store.dispatch("auth/loginAttempt", payload);
      return;
    }
  },
  beforeCreate() {
    //var self = this;
    document.title = "DigiCampus";
    localStorage.removeItem("userSiteInfo");
    // if(self.$route.query.token && self.$route.query.email)
    // {
    //   self.overlayVisible = true;
    //   var token = self.$route.query.token.trim();
    //   var email = self.$route.query.email.trim();

    //   localStorage.setItem('userInfo', '');
    //   const payload = {
    //     checkbox_remember_me: false,
    //     userDetails: {
    //       email: email,
    //       token: token
    //     },
    //     notify: self.$vs.notify,
    //     self: self
    //   };
    //   self.$store.dispatch("auth/loginAttempt", payload);
    //   return;
    // }
    this.$setSchoolTheme();
    this.$setColors();
  },
  methods: {
    eventListenerFunc(event) {
      var self = this;
      if (event.keyCode === 13 && self.email && self.password)
        self.login();
    },
    stopLoading() {
      this.$vs.loading.close(this.$refs.login.$el);
    },
    setCaption(){
        this.welcomeCaption = "Welcome, please login to your account.";
    },
    login() {
      localStorage.setItem('userInfo', '');
      this.showLoadingOnButton();
      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email.trim(),
          password: this.password.trim()
        },
        notify: this.$vs.notify,
        self: this
      };
      this.$vs.loading.close(this.$refs.login.$el);
      window.removeEventListener("keyup", this.eventListenerFunc, false);
      this.$store.dispatch("auth/loginAttempt", payload);
    },
    notifyAlreadyLogedIn() {
      this.stopLoading();
      this.$vs.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
    },
    showLoadingOnButton() {
      var self = this;
      self.$vs.loading({
        type: "material",
        container: self.$refs.login.$el,
        scale: 0.45
      });
    },
    viewRegisterPage() {
      if (window.location.href.includes("localhost")) {
        let routeData = this.$router.resolve({ name: 'DigiRegister', query: {siteid: 5} });
        window.open(routeData.href, '_blank');
      }
      else {
        this.$redirectToRegPage();
      }
    }
  }
};
</script>
